// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5z-2";
export var blackBorderOnHover = "_5z-7";
export var cell = "_5z-6";
export var cellContainer = "_5z-3";
export var checked = "_5z-8";
export var disabled = "_5z-5";
export var featuredIconCellContainer = "_5z-9";
export var featuredIconTextContainer = "_5z-b";
export var featuredIconWrapper = "_5z-a";
export var noBorder = "_5z-c";
export var orangeSelectedRow = "_es-3";
export var overflowableText = "_5z-0";
export var overflowableTextContainer = "_5z-1";
export var row = "_61-0";
export var rowCheckboxCell = "_5z-4";
export var selectableTable = "_es-2";